import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-ppk-downloader-start-time-help-dialog',
  templateUrl: './ppk-downloader-start-time-help-dialog.component.html',
  styleUrls: ['./ppk-downloader-start-time-help-dialog.component.scss']
})
export class PpkDownloaderStartTimeHelpDialogComponent {
  constructor(private readonly dialogRef: MatDialogRef<PpkDownloaderStartTimeHelpDialogComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}


